import React from 'react';
import shortid from '@wtdc/shortid';

import cookies from '@/utils/cookie';
import spider from '@/business/spider';
import Locator from '@/utils/locator';
import readercenter from '@/api/readercenter';
import appcenter from '@/api/appcenter';
import * as jwx from '@/utils/Jweixin';
import ShareConfig from '@/components/ShareConfig';
import { RAY_AVATAR } from '@/constants/common';
import { addTrack, trackObserver, TRACK_TYPE } from '@/business/spider/track';
import AuthWrap from '@/components/LoginModal/AuthWrap';
import Utils from '@/utils/utils';
import authUtils from '@/business/authorize/authUtils';
import EventEmitter from '@wtdc/eventemitter';
import Sentry from '@/business/sentry';
import PAGE from '@/constants/page';
import Loading from '@/components/Loading/Loading';
import crypto from '@/utils/crypto';
import { relateMessage } from '@/business/relate';
import { needTrackDigitalReport } from '@/utils/reportUtil';

import FooterTabBar from './component/FooterTabBar/FooterTabBar';
import InitData from './component/InitData/InitData';

import LabelContext from './LabelContext';

import { ConfigProvider } from 'antd-mobile';
import zhCN from 'antd-mobile/es/locales/zh-CN';

import './App.scss';

window.globalEmitter = new EventEmitter();

class App extends React.Component {

  fetchUserLabel = Utils.debounce(() => {
    readercenter.getUserGradeLabel()
      .then(data => {
        let res = Object.assign({}, data);
        function getType(userLabel) {
          let parentType = ''; // 1学龄前 2学生 3已工作
          if([1].includes(userLabel.parentId)) {
            parentType = 1;
          } else if([2, 3, 4, 5].includes(userLabel.parentId)) {
            parentType = 2;
          } else {
            parentType = 3;
          }
          return parentType;
        }
        res.parentType = getType(res);

        const toolList = formateList(res.parentId || res.labelId, TOOL_LIST);

        this.setState({ userLabel: res, toolList, loading: false });

        // if(res.parentId) {
        //   bookcenter.getToolListByUser().then(data => {
        //     const list = data.filter(v => v.userGradeLabelId === res.parentId);
        //     this.setState({ toolList: list });
        //   });
        // }
      });
  }, 20);

  addEntranceTrack = () => {
    const { query: { fromType = '' }} = Locator;
    // 埋点： 从何处进入H5-- 1小程序，2公众号菜单，3关注公众号后推出的消息进入，4微信扫码进入
    addTrack({
      type: TRACK_TYPE.BROWSE,
      spm: '1507',
      subSpm: fromType
    });
  }

  toPageTop=(delay) => {
    window.setTimeout(() => {
      window.document.body.scrollIntoView(true);
    }, delay);
  }

  state = {
    userId: '',
    userLabel: {}, // parentType: 1学龄前 2学生 3已工作
    toolList: [],
    loading: true
  }

  componentDidMount() {
    relateMessage();
    const { query } = Locator;
    console.log('Locator', Locator);
    jwx.init();
    const userId = cookies.getItem('wechatUserId');
    const officialId = cookies.getItem('officialAccountsId');
    this.setState({
      userId: userId
    });
    Sentry.setUser({
      id: userId
    });
    spider.setUserId(userId);
    if(authUtils.getUserType()) {
      spider.setUserType(authUtils.getUserType());
    }
    spider.setPara({
      content: {
        officialId: officialId,
        bookId: query.bookId,
        qrcodeId: query.sceneId || query.bookGroupId,
        contentExtra: {
          bookGroupId: query.bookGroupId,
          adviserId: query.adviserId,
          channelId: query.channelId
        }
      }
    });

    /**
     * query使用url里面的query
     * 而不是locator里面的query
     * 因为locator里面的query不能保证一定是正确的
     * 会因为在同一次会话中多次进入不同的应用/作品导致混乱
     */
    const trackQuery = Object.assign({}, this.props.query);
    appcenter.getListAllRaysAppWithDelete().then(res => {
      const query = trackQuery;
      spider.appList = res;
      spider.init();
      if(needTrackDigitalReport({ spm: 4497 }) && Number(query.serverId)) {
        const isFree = query.isFree;
        let isFreeParam = 0; //0 免费 1 付费
        if(isFree && !Number.isNaN(Number(isFree))) {
          isFreeParam = Number(isFree);
        }
        trackObserver({
          type: TRACK_TYPE.CLICK,
          spm: 4497,
          subSpm: {
            click_name: query.typeCode,
            id: query.serverId * 1,
            service_type: query.serviceType,
            is_free: isFreeParam,
            origin: query.origin
          }
        });
      }
    });

    this.addEntranceTrack();

    this.fetchUserLabel();
    // 小程序环境内嵌的时候 合并用户信息
    if(Utils.isWeAppEnv() && query.miniOfficialAccountsId && query.miniUserId) {
      const originCookie = {
        officialAccountsId: query.miniOfficialAccountsId,
        wechatUserId: query.miniUserId
      };
      readercenter.miniGzhUserRelate({
        ciphertext: crypto.aesEncrypt({
          miniOfficialAccountsId: originCookie.officialAccountsId,
          miniWechatUserId: originCookie.wechatUserId,
          gzhOfficialAccountsId: officialId,
          gzhWechatUserId: userId
        })
      }).then(data => {
        if(data === 1) {
          window.location.reload();
        }
      });
    }

    //超过一屏的页面滑动到底部，点击链接出去，再go back回来之后会出现屏幕空白的情况
    window.addEventListener('load', () => {
      this.toPageTop(200);
    });
  }

  componentWillReceiveProps(nextProps, nextContext) {
    const { location: { pathname: nextPathname }} = nextProps;
    const { location: { pathname }} = this.props;
    if(pathname && nextPathname && pathname !== nextPathname) {
      this.toPageTop(200);
    }
    // 进入首页要刷新用户标签
    if(pathname && nextPathname && pathname !== nextPathname && nextPathname.includes(PAGE.HOME)) {
      this.fetchUserLabel();
    }
  }

  componentDidCatch(error, info) {
    // 将component中的报错发送到Fundebug
    window.fundebug && window.fundebug.notifyError(error, {
      metaData: {
        info: info
      }
    });
  }

  render() {
    const { userLabel, toolList, loading, userId } = this.state;
    const { query: { bookType }} = this.props;
    return <div className={'App-container'}>
      <LabelContext.Provider
        value={{
          fetchUserLabel: this.fetchUserLabel,
          userLabel: userLabel,
          toolList: toolList
        }}
      >
        <ConfigProvider locale={zhCN}>
          {this.props.children}
        </ConfigProvider>
      </LabelContext.Provider>

      <Loading loading={loading} />

      {bookType !== 'newBookType' && <FooterTabBar />}
      <ShareConfig
        config={{
          title: '书童小睿',
          desc: '书童小睿，伴你读书，提供阅读和学习工具',
          imgUrl: RAY_AVATAR,
          link: window.location.href
        }}
        topSize={0}
      />
      {!!userId && <AuthWrap />}
      <InitData />
    </div>;
  }
}

export default App;

// 为了使用方便，赋值在window上
window.shortid = shortid;

const TOOL_LIST = [
  // { toolType: 1, toolName: '家长互助', title1: '学伴互助', title2: '书友互助' },
  { toolType: 2, toolName: '家长打卡', title1: '学习打卡' },
  { toolType: 3, toolName: '搜答案' },
  { toolType: 4, toolName: '搜教辅资料', title1: '育儿宝库' },
  { toolType: 5, toolName: '背单词' },
  { toolType: 6, toolName: '智能题库' },
  // { toolType: 7, toolName: '错题本' },
  // { toolType: 8, toolName: '1v1老师答疑' },
  { toolType: 9, toolName: '好课推荐' },
  { toolType: 10, toolName: '精选书单' },
  // { toolType: 11, toolName: '资料打印' },
  { toolType: 13, toolName: '口算批改' },
  { toolType: 14, toolName: '错题集' }
  // { toolType: 15, toolName: '小睿图书馆' }
];

// 学龄前：  家长互助、家长打卡、口算批改、育儿宝库
const BEFORE_SCHOOL_LIST = [1, 2, 13, 4, 9, 10, 11];
// 小学：找答案、错题集、口算批改、学伴互助、学习打卡、背单词、搜教辅资料
const PRIMARY_SCHOOL_LIST = [3, 14, 13, 1, 2, 4, 5, 9, 10, 11];
// 初中：找答案、智能题库、错题集、学伴互助、学习打卡、背单词、搜教辅资料
const MIDDLE_SCHOOL_LIST = [3, 6, 14, 1, 2, 4, 5, 9, 10, 11];
// 高中：找答案、错题集、学伴互助、学习打卡、背单词、搜教辅资料
const HIGH_SCHOOL_LIST = [3, 14, 1, 2, 4, 5, 9, 10, 11];
// 大学：找答案、错题集、学伴互助、学习打卡、背单词
const COLLEGE_LIST = [3, 14, 1, 2, 5, 9, 10, 11];
// 已工作：书友互助、家长打卡、背单词
const GRADUATED_LIST = [1, 2, 5, 9, 10, 11];
/** 根据学段过滤列表 */
function formateList(labelId, typeList = []) {
  let list = [];
  if([1].includes(labelId)) {
    list = BEFORE_SCHOOL_LIST;
  } else if([2].includes(labelId)) {
    list = PRIMARY_SCHOOL_LIST;
  } else if([3].includes(labelId)) {
    list = MIDDLE_SCHOOL_LIST;
  } else if([4].includes(labelId)) {
    list = HIGH_SCHOOL_LIST;
  } else if([5].includes(labelId)) {
    list = COLLEGE_LIST;
  } else if([6].includes(labelId)) {
    list = GRADUATED_LIST;
  }
  const _list = list.map(key => typeList.find(e => e.toolType === key))
    .filter(e => e)
    .map(e => {
      if(e.toolType === 1) {
        if([2, 3, 4, 5].includes(labelId)) return { toolType: e.toolType, toolName: e.title1 }; // 学伴互助
        if([6].includes(labelId)) return { toolType: e.toolType, toolName: e.title2 }; // 书友互助
      } else if(e.toolType === 2) {
        if([2, 3, 4, 5].includes(labelId)) return { toolType: e.toolType, toolName: e.title1 }; // 学习打卡
      } else if(e.toolType === 4) {
        if(labelId === 1) return { toolType: e.toolType, toolName: e.title1 }; // 育儿宝库
      }
      return e;
    });
  return _list;
}

// const ALL_TOOL_LIST = {
//   1: '学伴互助', // 家长互助
//   2: '学习打卡', // 家长打卡
//   3: '搜答案',
//   4: '搜教辅资料', // 育儿宝库
//   5: '背单词',
//   6: '智能题库',
//   7: '错题本',
//   8: '1v1老师答疑',
//   9: '好课推荐',
//   10: '精选书单'
//   11: '资料打印'
//   12: '玩转小睿'
//   13: '口算批改'
//   14: '错题集'
// };
